module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvZm9udHMva25ld2F2ZS4wMTgyYjBiLnR0ZiI7"


//////////////////
// WEBPACK FOOTER
// ./node_modules/base64-loader!./node_modules/scratch-render-fonts/src/knewave.ttf
// module id = 4sX1
// module chunks = 0